import { APIClient } from "api/api_helper";
import { PRINT_REPORT_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();

export interface PrintReportPayload {
  barcodetype: string;
  studyid: number | string | null;
  [key: string]: any;
}

export const printReportApiService = {
  selectAll: (payload_data: PrintReportPayload) => {
    const user = GetUserData() as CurrentUser;

    const payload = {
      barcodetype: payload_data.barcodetype,
      studyid: payload_data.studyid ? Number(payload_data.studyid) : null,
      periodnumber: payload_data.periodnumber ?? payload_data.period ?? null,
      timepointnumber: payload_data.timepointnumber ?? payload_data.timepoint ?? null,
      aliquotnumber: payload_data.aliquotnumber ?? payload_data.aliquot ?? null,
      generatedby: user.userid,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    return api.create(PRINT_REPORT_API.PRINT_REPORT_API + "SelectAll", payload, {
      responseType: "blob",
    });
  },
};
